<template>
<div class="chapter">
<div class="inner_page">
<p class="imagefp"><img alt="Cover: P. D. James's Cordelia Gray Mysteries, by P.D. James" class="imagefp" src="images/9781501117565.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?006caea5